import { useTranslation } from 'react-i18next';
import NotificationBlock from '@/containers/NotificationBlock';
import { useGetNextRepayment } from '@/query/queries/cash/useGetNextRepayment';
import { useGetMe } from '@/hooks/shared/useGetMe';
import { prettyFloatMoney } from '@/helpers/utils';
import { APP_LINKS } from '@/helpers/links';
import { RoundLink } from '@/components/UI/RoundLink';
import { NOTIFICATIONS as NOTIFICATIONS_T } from '@/components/Notification/list';
import s from './index.module.scss';

export const StepResult = ({ status }) => {
  const { data: nextPayment } = useGetNextRepayment();
  const { isMainFounder } = useGetMe();
  const { t } = useTranslation('fundraising');
  const { tCommon } = useTranslation('common');
  const NOTIFICATIONS = NOTIFICATIONS_T(tCommon);

  if (!status) return null;

  const { raised, goal, disbursement_fee, cash_received } = status;
  const notifications = [];
  const isRaisedFunds = raised >= goal;
  const hasLoans = raised > 0;

  hasLoans
    ? notifications.push(NOTIFICATIONS.your_loan_successfully_completed(raised))
    : notifications.push(NOTIFICATIONS.not_enough_investor_to_fund());

  hasLoans && notifications.push(NOTIFICATIONS.origination_fee_charged(disbursement_fee));

  const firstPayment =
    nextPayment && !!Number(nextPayment.total_amount) && prettyFloatMoney(nextPayment.total_amount);

  hasLoans &&
    firstPayment &&
    notifications.push(NOTIFICATIONS.next_montly_repayment(firstPayment, nextPayment.deadline));

  return (
    <div className={s.wrapper}>
      <div className="container-inner">
        {!hasLoans ? (
          <h1 className="f-hero-h5">{t('step_result.this_fundraising_is_over')}</h1>
        ) : isRaisedFunds ? (
          <h1 className="f-hero-h5">
            {t('step_result.congrats_goal_achieved')} <br />{' '}
            {t('step_result.transferred_amount', { amount: prettyFloatMoney(cash_received) })}
          </h1>
        ) : (
          <h1 className="f-hero-h5">{t('step_result.congrats_loans_received')}</h1>
        )}
        <NotificationBlock notifications={notifications} className={s.notifications} />
        {isMainFounder && (
          <div className={s.buttons}>
            {hasLoans && (
              <RoundLink
                label={t('step_result.withdraw_funds')}
                path={APP_LINKS.withdraw}
                className={s.button}
                fillBackground
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
